import api from '@/api'
import {
  COURIER_PRICE_LIMIT,
  NOVA_POSHTA_COURIER_PRICE_LIMIT,
  NOVA_POSHTA_POSTOMAT_PRICE_LIMIT,
  NOVA_POSHTA_PRICE_LIMIT,
  UKR_POSHTA_PRICE_LIMIT
} from '@/constants'
const saveToLocalStorage = (state) => {
  try {
    localStorage.setItem('deliveryNewData', JSON.stringify(state.formData))
  } catch (e) {}
}

export default {
  namespaced: true,
  state: {
    formData: {
      deliveryCity: {},
      deliveryMethod: {},
      deliveryInfo: {},
      selectedSpot: {},
      courierData: {}
    },
    deliveryMethods: [],
    deliveryCities: [],
    deliveryStreets: [],
    courierDataErrors: {},
    isOpen: false,
    pending: true,
    isDeliveryReady: false
  },
  getters: {
    isDeliveryFormValid (state) {
      if (state.formData.deliveryMethod.method_id === 2 || state.formData.deliveryMethod.method_id === 4 || state.formData.deliveryMethod.method_id === 6) {
        const arrayOfErrors = Object.values(state.courierDataErrors)
        const errorsStr = arrayOfErrors.reduce((acc, curr) => acc + curr, '')
        const isValidTime = state.formData.deliveryMethod.method_id === 6 || state.formData.deliveryMethod.method_id === 2 ? state.formData.courierData.time && state.formData.courierData.time.date && state.formData.courierData.time.title : true
        return !errorsStr.length && state.formData.courierData.street && state.formData.courierData.house && isValidTime
      } else {
        return Object.keys(state.formData.selectedSpot).length > 0 && state.formData.deliveryMethod.method_id
      }
    },
    deliveryPrice: (state, getters, rootState, rootGetters) => data => {
      const { spentBonuses, useBonuses } = rootState.checkoutNew.formData
      const { originCost } = rootState.cart.cart
      const item = data || state.formData.deliveryMethod
      const deliveryCost = item.full_cost ? item.full_cost : 0
      const bonusesValue = useBonuses ? spentBonuses : 0
      // костыль УП
      if (item.method_id === 5) {
        return (originCost - bonusesValue) > UKR_POSHTA_PRICE_LIMIT ? 0 : deliveryCost
      }
      // костыль курьер НП
      if (item.method_id === 4) {
        return (originCost - bonusesValue) > NOVA_POSHTA_COURIER_PRICE_LIMIT ? 0 : deliveryCost
      }
      // костыль отделение НП
      if (item.method_id === 3) {
        return (originCost - bonusesValue) > NOVA_POSHTA_PRICE_LIMIT ? 0 : deliveryCost
      }
      // костыль Курьер
      if (item.method_id === 2) {
        return (originCost - bonusesValue) > COURIER_PRICE_LIMIT ? 0 : deliveryCost
      }
      if (item.method_id === 7) {
        return (originCost - bonusesValue) > NOVA_POSHTA_POSTOMAT_PRICE_LIMIT ? 0 : deliveryCost
      }
      return deliveryCost
    }
  },
  mutations: {
    SET_PENDING (state, data) {
      state.pending = data
    },
    SET_IS_DELIVERY_READY (state, data) {
      state.isDeliveryReady = data
    },
    SET_OPEN (state, data) {
      state.isOpen = data
    },
    SET_STREETS (state, data) {
      state.deliveryStreets = data
    },
    SET_SELECTED_SPOT (state, data) {
      state.formData.selectedSpot = data
      if (Object.keys(data).length) {
        saveToLocalStorage(state)
      }
    },
    SET_COURIER_DATA (state, data) {
      if (!data) {
        state.formData.courierData = {}
        saveToLocalStorage(state)
        return
      }
      state.formData.courierData = { ...state.formData.courierData, ...data }
      saveToLocalStorage(state)
    },
    SET_COURIER_ERRORS (state, data) {
      state.courierDataErrors = { ...state.courierDataErrors, ...data }
    },
    SET_CITY (state, data) {
      state.formData.deliveryCity = data
      saveToLocalStorage(state)
    },
    SET_CITIES (state, data) {
      // если поиск не нашел города и вернул пустой массив - не перезатирать текущие
      if (data.length > 0) {
        state.deliveryCities = data
      }
    },
    SET_DATA (state, data) {
      state.formData = { ...state.formData, ...data }
      saveToLocalStorage(state)
    },
    SET_DELIVERY_METHODS (state, data) {
      state.deliveryMethods = data
    },
    SET_DELIVERY_METHOD (state, data) {
      state.formData.deliveryMethod = data
      saveToLocalStorage(state)
    },
    SET_DELIVERY_INFO (state, data) {
      state.formData.deliveryInfo = data
    }
  },
  actions: {
    SET_DELIVERY_PENDING ({ commit }, data) {
      commit('SET_PENDING', data)
    },
    SET_DELIVERY_IS_OPEN ({ commit }, data) {
      commit('SET_OPEN', data)
    },
    FETCH_STREETS: ({ state, commit }, value) => {
      if (!value) {
        commit('SET_STREETS', [])
        return
      }
      api.checkout.getDeliveryStreets({
        cityId: state.formData.deliveryCity.id || '',
        cityName: value || ''
      }).then(res => {
        commit('SET_STREETS', res.streets)
      })
    },
    SET_COURIER_DATA ({ commit }, data) {
      commit('SET_COURIER_DATA', data)
    },
    SET_SELECTED_SPOT ({ commit, dispatch }, data) {
      commit('SET_SELECTED_SPOT', data)
      if (data && Object.keys(data).length) {
        dispatch('paymentNew/FETCH_PAYMENT_METHODS', {}, { root: true })
      }
    },
    SET_DELIVERY_CITY ({ commit }, data) {
      commit('SET_CITY', data)
    },
    FETCH_DELIVERY_CITIES ({ commit, rootGetters, state }, data) {
      let query = ''
      // прелоадер селекта
      if (data && data.loading) {
        data.loading(true)
      }
      if (data && data.city) {
        query = data.city
      }
      api.checkout.getCities(query)
        .then(res => {
          commit('SET_CITIES', res.cities)
          // прелоадер селекта
          if (data && data.loading) {
            data.loading(false)
          }
        })
    },
    FETCH_DELIVERY_TYPES ({ commit, rootGetters, rootState, dispatch, state }) {
      commit('SET_PENDING', true)
      commit('SET_IS_DELIVERY_READY', false)
      const params = { cityId: state.formData.deliveryCity.id || '' }
      if (rootState.user?.userType && rootState.user?.userType === 'manager') {
        params.checkout_as_client = true
      }
      api.checkout.getDeliveryMethods(params).then(response => {
        commit('SET_DELIVERY_METHODS', response.delivery_methods)
        const selectedDeliveryMethod = response.delivery_methods.find(el => el.method_id === state.formData.deliveryMethod.method_id)
        if (!selectedDeliveryMethod) {
          // commit('SET_OPEN', true)
          commit('SET_DELIVERY_METHOD', {})
          commit('SET_SELECTED_SPOT', {})
          commit('paymentNew/SET_PENDING', false, { root: true })
        } else {
          // dispatch('SET_DELIVERY_METHOD', selectedDeliveryMethod)
          commit('paymentNew/SET_PENDING', true, { root: true })
          dispatch('FETCH_DELIVERY_INFO')
        }
      }).finally(() => {
        commit('SET_PENDING', false)
        commit('SET_IS_DELIVERY_READY', true)
      })
    },
    FETCH_DELIVERY_INFO ({ commit, state, rootState, dispatch }) {
      commit('SET_DELIVERY_INFO', {})
      commit('SET_PENDING', true)
      const params = {
        cityId: state.formData.deliveryCity.id || '',
        methodId: state.formData.deliveryMethod.method_id || ''
      }
      if (rootState.checkout.isManagerPage && rootState.checkout.managersClientData?.phone) {
        params.client_phone = rootState.checkout.managersClientData.phone
      }
      api.checkout.getDeliveryInfo(params).then(response => {
        commit('SET_DELIVERY_INFO', response)
        // логика очистки выбранной точки на карте (магазин, почтомат итд) если после обновления списка точек она или недоступна или пропала
        if (Array.isArray(response.delivery_data) && state.formData.selectedSpot.uid) {
          const selectedSpot = response.delivery_data.find(el => el.ref === state.formData.selectedSpot.uid || el.uid === state.formData.selectedSpot.uid || el.index === state.formData.selectedSpot.uid)
          if (!selectedSpot) {
            commit('SET_SELECTED_SPOT', {})
            commit('SET_OPEN', true)
          }
        }
        if (state.formData.deliveryMethod.method_id === 2) {
          const resetTime = () => {
            let oldCourierData = state.formData.courierData
            if (oldCourierData['time']) {
              delete oldCourierData['time']
            }
            dispatch('SET_COURIER_DATA', null)
            dispatch('SET_COURIER_DATA', oldCourierData)
            // dispatch('SET_DELIVERY_IS_OPEN', true)
          }
          if (state.formData.courierData?.time && state.formData.courierData?.time?.date && state.formData.courierData?.time?.title) {
            const currentDateTimeArray = response.delivery_data[state.formData.courierData?.time?.date]
            if (currentDateTimeArray) {
              const hasTheSameTime = currentDateTimeArray.find(el => el.title === state.formData.courierData.time.title)
              if (!hasTheSameTime) {
                resetTime()
              }
            } else {
              resetTime()
            }
          }
        }
        dispatch('paymentNew/FETCH_PAYMENT_METHODS', {}, { root: true })
      }).finally(() => {
        commit('SET_PENDING', false)
      })
    },
    SET_DELIVERY_METHOD ({ commit, dispatch }, data) {
      commit('SET_DELIVERY_METHOD', data)
      dispatch('FETCH_DELIVERY_INFO')
    },
    SET_DELIVERY_DATA ({ commit }, data) {
      commit('SET_DATA', data)
    },
    SET_COURIER_ERRORS ({ commit }, data) {
      commit('SET_COURIER_ERRORS', data)
    }
  }
}
